module.exports = function() {
  return new Worker(__webpack_public_path__ + "8d1628272642efe0362c.worker.js");
};